// Validadores simples para o cadastro de entregadores

export const onlyDigits = (s = '') => s.replace(/\D/g, '');

export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const isValidPhone = (phone) => {
  const d = onlyDigits(phone);
  // BR: 10 ou 11 dígitos com DDD
  return d.length === 10 || d.length === 11;
};

export const isValidCPF = (cpf) => {
  const c = onlyDigits(cpf);
  if (c.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(c)) return false;

  const calc = (slice) => {
    let sum = 0;
    for (let i = 0; i < slice.length; i++) {
      sum += parseInt(slice[i], 10) * (slice.length + 1 - i);
    }
    const r = (sum * 10) % 11;
    return r === 10 ? 0 : r;
  };

  return calc(c.slice(0, 9)) === parseInt(c[9], 10) &&
         calc(c.slice(0, 10)) === parseInt(c[10], 10);
};

export const isValidPlate = (plate) => {
  const p = (plate || '').toUpperCase().replace(/[\s-]/g, '');
  // Antiga ABC1234 ou Mercosul ABC1D23
  return /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(p);
};

export const isAdult = (birthDateStr) => {
  if (!birthDateStr) return false;
  const birth = new Date(birthDateStr);
  if (isNaN(birth.getTime())) return false;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age >= 18 && age < 100;
};

export const isValidYear = (year) => {
  const y = parseInt(year, 10);
  const current = new Date().getFullYear();
  return !isNaN(y) && y >= 1990 && y <= current + 1;
};

// Máscaras
export const maskCPF = (v = '') => {
  const d = onlyDigits(v).slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

export const maskPhone = (v = '') => {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length <= 10) {
    return d
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }
  return d
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2');
};

export const maskPlate = (v = '') => {
  return (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 7);
};
